import React from 'react';
import IconButton from '@material-ui/core/IconButton';
import Right from '@material-ui/icons/ChevronRightRounded';
import { IArrowProps } from '../../EventToday/ArrowRight';

export const RightArrow = ({ onClick }: IArrowProps) => (
  <IconButton className="arrow" onClick={onClick}>
    <Right color="primary" fontSize="large" />
  </IconButton>
);
